// extracted by mini-css-extract-plugin
export default {"toast":"RateLimitToast_toast__eUikZ","slideDown":"RateLimitToast_slideDown__ABPKQ"};